import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CloseButton from 'components/CloseButton';
import EcoFeeModalContent from './components/EcoFeeModalContent';
import { getText } from 'helpers/i18n';

const EcoFeeModal = ({ fee, isOpen, onRequestClose, regularPrice }) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel={getText('product_eco_participation_' + fee.type)}
        className="one-checkout ikea-modal__content"
        overlayClassName="ikea-modal__overlay"
    >
        <CloseButton onClick={onRequestClose} container="modal" />
        <EcoFeeModalContent
            fee={fee}
            regularPrice={regularPrice}/>
    </Modal>
);

export default EcoFeeModal;

EcoFeeModal.propTypes = {
    fee: PropTypes.shape({
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        type: PropTypes.string.isRequired,
    }),
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    regularPrice: PropTypes.number.isRequired,
};

